import { gql } from 'apollo-angular'

import {
  ARTICLE_BASIC_FIELDS,
  ARTICLE_EXTENDED_EDITION_FIELDS,
  ARTICLE_EXTENDED_MAGAZINE_FIELDS,
  ARTICLE_FOOTNOTES_FIELDS,
} from '../../fragments/article-fragments'
import { AUTHOR_EXTENDED_FIELDS } from '../../fragments/author.fragments'
import { SEO_META_FIELDS } from '../../fragments/seo.fragment'

export const GET_ARTICLE_DETAILS = gql`
  ${ARTICLE_BASIC_FIELDS}
  ${ARTICLE_EXTENDED_EDITION_FIELDS}
  ${ARTICLE_EXTENDED_MAGAZINE_FIELDS}
  ${ARTICLE_FOOTNOTES_FIELDS}
  ${AUTHOR_EXTENDED_FIELDS}
  query getArticleDetails($articleId: Int!) {
    Article(id: $articleId, select: true) {
      ...ArticleBasicFields
      subtitle
      pdf
      purchase_price
      user_access
      users {
        authors {
          ...AuthorExtendedFields
        }
        creators {
          ...AuthorExtendedFields
        }
      }
      sub_articles {
        ...ArticleBasicFields
        users {
          authors {
            ...AuthorBasicFields
          }
          creators {
            ...AuthorBasicFields
          }
        }
      }
      references {
        type
        value
        ecli_organization_type
        id
      }
      ...ArticleExtendedEditionFields
      ...ArticleExtendedMagazineFields
      ...ArticleFootnotesFields
      ${SEO_META_FIELDS}
    }
  }
`
